import { render, staticRenderFns } from "./HeaderChat.vue?vue&type=template&id=2d7b6558&scoped=true&"
import script from "./HeaderChat.vue?vue&type=script&lang=js&"
export * from "./HeaderChat.vue?vue&type=script&lang=js&"
import style0 from "./HeaderChat.vue?vue&type=style&index=0&id=2d7b6558&prod&lang=sass&scoped=true&"
import style1 from "./HeaderChat.vue?vue&type=style&index=1&id=2d7b6558&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b6558",
  null
  
)

export default component.exports